import t from "./index435.js";
import { resolveComponent as r, createElementBlock as n, createCommentVNode as a, openBlock as s, createVNode as l, createTextVNode as p, toDisplayString as i } from "vue";
import m from "./index231.js";
const c = ["data-component", "href", "target", "rel"];
function f(e, d, k, u, g, h) {
  const o = r("ms-user");
  return e.link ? (s(), n("a", {
    key: 0,
    "data-component": e.$options.name,
    href: e.link.url,
    target: e.link.target,
    rel: e.getRel(e.link.nofollow),
    class: "flex items-center gap-8 whitespace-nowrap"
  }, [
    l(o, { class: "h-24 w-25" }),
    p(" " + i(e.link.text), 1)
  ], 8, c)) : a("", !0);
}
const N = /* @__PURE__ */ m(t, [["render", f]]);
export {
  N as default
};
